import { AbstractMatrix } from '../matrix';

export default class WrapperMatrix2D extends AbstractMatrix {
  constructor(data) {
    super();
    this.data = data;
    this.rows = data.length;
    this.columns = data[0].length;
  }

  set(rowIndex, columnIndex, value) {
    this.data[rowIndex][columnIndex] = value;
    return this;
  }

  get(rowIndex, columnIndex) {
    return this.data[rowIndex][columnIndex];
  }
}



//////////////////
// WEBPACK FOOTER
// ./node_modules/@antv/layout/node_modules/ml-matrix/src/wrap/WrapperMatrix2D.js
// module id = null
// module chunks = 